import * as React from 'react'
import SettingsStore from '../../../Stores/SettingsStore'
import SettingsView from '../../PartialViews/Settings/SettingsView'
import { inject, observer } from 'mobx-react'
import HttpActionsService from '../../../Services/HttpActionsService'
import SettingUpdateView from '../../PartialViews/Settings/SettingUpdateView'
import PageSizeComponent from '../../../Components/PageSizeComponent'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import { Button, Modal } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import ActionsLocalService from '../../../Services/ActionsLocalService'

export interface ISettingsPageProps {
    settingsStore?: SettingsStore
    httpActionsService?: HttpActionsService
    localizationStore?: LocalizationStore
    actionsLocalService?: ActionsLocalService
}

@inject('settingsStore')
@inject('httpActionsService')
@inject('localizationStore')
@inject('actionsLocalService')
@observer
export default class SettingsPage extends React.Component<ISettingsPageProps> {

    componentDidMount() {
        this.props.httpActionsService!.getAllSettings()
    }

    handleClose(e: any, context: any) {
        this.props.actionsLocalService!.setSettingToDelete(null)
    }

    render() {
        const { httpActionsService, actionsLocalService, settingsStore, localizationStore } = this.props
        return (
            <div className="settings-page pageCol-6">

                <Modal
                    show={!!settingsStore!.getSettingToDelete}
                    onHide={() => { return }}
                    animation={false}
                    keyboard={false}
                    backdrop={true}
                >
                    <div className="formWrapper">
                        <div>
                            <h4>{localizationStore!.t!('Do you really want to delete this setting?')}</h4>
                            <p>
                                {`${localizationStore!.t!('Key')}: 
                                ${settingsStore!.getSettingToDelete! ? settingsStore!.getSettingToDelete!.key : ''}`}
                            </p>

                            <p>
                                {`${localizationStore!.t!('Value')}: 
                                ${settingsStore!.getSettingToDelete! ? settingsStore!.getSettingToDelete!.value : ''}`}
                            </p>
                        </div>
                        <Button
                            className="btn-danger"
                            onClick={
                                (e) => {
                                    httpActionsService!.deleteSetting(settingsStore!.getSettingToDelete!.key)
                                    actionsLocalService!.setSettingToDelete(null)
                                }}
                        >
                            {localizationStore!.t!('Delete')}
                        </Button>
                        <Button
                            bsStyle="link"
                            onClick={(e) => { return this.handleClose(e, this) }}
                        >
                            {localizationStore!.t!('Back')}
                        </Button>
                    </div>
                </Modal>

                <SettingUpdateView />
                <hr />

                <PageSizeComponent />
                <ExportToCsvComponent exportType={ExportType.Settings} />
                <SettingsView settings={settingsStore!.getSettings} />
                <Button onClick={()=>{ httpActionsService!.clearSettingsCache() }}>
                    Clear Settings Cache
                </Button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Setting/SettingsPage.tsx